import React from "react";
import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const ACTION_STYLE = {
  remove: "text-[#C084FC]", ban: "text-red-400", unban: "text-emerald-400",
  approve: "text-emerald-400", auto_blocked: "text-amber-300", filters_updated: "text-sky-300",
};
const ACTION_LABEL = { remove: "Removed", ban: "Banned", unban: "Unbanned", approve: "Approved", auto_blocked: "Auto-blocked", filters_updated: "Filters updated" };

export default function ModerationLog() {
  const { data = [], isLoading } = useQuery({
    queryKey: ["admin-log"],
    queryFn: async () => (await api.get("/admin/log")).data,
  });
  if (isLoading) return <Loader2 className="w-6 h-6 animate-spin text-[#8012C6] mx-auto" />;
  if (!data.length) return <div data-testid="log-empty" className="bg-card border border-border rounded-2xl p-10 text-center text-sm text-muted-foreground">No moderation actions yet.</div>;
  return (
    <div data-testid="moderation-log" className="bg-card border border-border rounded-2xl divide-y divide-border">
      {data.map((l) => (
        <div key={l.id} data-testid={`log-row-${l.id}`} className="p-4 text-sm">
          <div className="flex items-center gap-2 flex-wrap">
            <span className={`font-semibold ${ACTION_STYLE[l.action] || ""}`}>{ACTION_LABEL[l.action] || l.action}</span>
            {l.target_type && l.target_type !== "settings" && <span className="text-xs px-2 py-0.5 rounded-full bg-secondary">{l.target_type.replace("_", " ")}</span>}
            {l.target_user_name && <span className="text-muted-foreground">· {l.target_user_name}</span>}
            <span className="ml-auto text-xs text-muted-foreground">{format(new Date(l.created_at), "MMM d, HH:mm")}</span>
          </div>
          <div className="text-xs text-muted-foreground mt-1">
            by {l.admin_name}{l.reason ? ` · ${l.reason}` : ""}{l.note ? ` · "${l.note}"` : ""}
          </div>
          {l.snapshot?.content && <p className="mt-2 text-xs bg-secondary rounded-lg px-3 py-2 line-clamp-2 break-words">{l.snapshot.content}</p>}
        </div>
      ))}
    </div>
  );
}
